var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgZalo = function SvgZalo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.653 13.696v-.6h1.796v8.43h-1.026a.77.77 0 0 1-.77-.765A4.379 4.379 0 0 1 9.69 17.23a4.379 4.379 0 0 1 6.963-3.533m-7.428-3.31v.274c0 .51-.068.925-.4 1.413l-.04.046q-.165.186-.322.38l-5.764 7.234h6.526v1.024a.77.77 0 0 1-.769.768H0v-.482c0-.59.147-.855.333-1.13l6.144-7.606H.256v-1.92zm11.402 11.14a.64.64 0 0 1-.64-.64v-10.5h1.921v11.14zM27.59 12.8a4.406 4.406 0 0 1 3.119 7.524 4.408 4.408 0 1 1-3.12-7.524m-13.52 7.004a2.576 2.576 0 1 0 .116-5.151 2.576 2.576 0 0 0-.116 5.151m13.52-.004a2.593 2.593 0 1 0 0-5.187 2.593 2.593 0 0 0 0 5.187"
  })));
};
export default SvgZalo;